import { render } from "./business_profile_view.html?vue&type=template&id=c1ddf79c&scoped=true&external"
import script from "./business_profile_view.js?vue&type=script&lang=js&external"
export * from "./business_profile_view.js?vue&type=script&lang=js&external"

import "../../assets/css/new_style.css?vue&type=style&index=0&id=c1ddf79c&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c1ddf79c"]])

export default __exports__